import React, { createContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RouteContents from "../../constants/routesContent.json";
import { nonEmpty, validateMobileNumber } from "../../utils/service";
import validateEmail from "../../utils/service";
import moment from "moment";
import {
  createEmployee,
  editEmployee,
  getEmployeeDetail,
  getCategoryList,
  getERTList,
  createEmpGroup,
} from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";

export const EmployeeRegistrationContext = createContext({});
export const EmployeeRegistartionContextProvider = ({ children }) => {
  const location = useLocation();
  const employeeInfo = location?.state?.employeeData;

  const [displayName, setDisplayName] = useState(
    employeeInfo ? employeeInfo.EmployeeName : null
  );
  const isEdit = location?.state?.isEdit || "";

  const [entryType, setEntryType] = useState("I");

  const setEmployeeEntryType = () => {
    if (entryType === "I") {
      setEntryType("G");
    } else if (entryType === "G") {
      setEntryType("I");
    }
  };

  const [groupExcelRequired, setGroupExcelRequired] = useState(true);
  const [groupExcelFile, setGroupExcelFile] = useState("");
  const [groupExcelFileLabel, setGroupExcelFileLabel] = useState("");

  const [fullName, setFullName] = useState(
    employeeInfo && employeeInfo?.EmployeeName ? employeeInfo?.EmployeeName : ""
  );
  const [employeeCode, setEmployeeCode] = useState(
    employeeInfo && employeeInfo?.EmployeeCode ? employeeInfo?.EmployeeCode : ""
  );

  // const [birthDate, setBirthDate] = useState(
  //   employeeInfo && new Date(employeeInfo?.DOB).toLocaleDateString()
  //     ? new Date(employeeInfo?.DOB).toLocaleDateString()
  //     : ""
  // );
  var dateOfBirth = employeeInfo?.DOB
    ? new Date(employeeInfo?.DOB).toLocaleDateString()
    : "";
  dateOfBirth = dateOfBirth ? moment(dateOfBirth).format("YYYY-MM-DD") : "";

  const initialBdate = employeeInfo && dateOfBirth ? dateOfBirth : "";

  const [employeeSpinnerStatus, setEmployeeSpinnerStatus] = useState(false);

  const [birthDate, setBirthDate] = useState(
    employeeInfo && dateOfBirth ? dateOfBirth : ""
  );

  const [email, setEmail] = useState(
    employeeInfo && employeeInfo?.Email ? employeeInfo?.Email : ""
  );
  const [emergencyContactNo, setEmergencyContactNo] = useState(
    employeeInfo && employeeInfo?.EmergencyContact
      ? employeeInfo?.EmergencyContact
      : ""
  );
  const [ertRole, setErtRole] = useState(
    employeeInfo && employeeInfo?.name ? employeeInfo?.name : "Select"
  );
  const [addPhoto, setAddPhoto] = useState(
    employeeInfo && employeeInfo?.Image ? employeeInfo?.Image : ""
  );

  const [photoLabel, setPhotoLabel] = useState(
    employeeInfo && employeeInfo.Image ? employeeInfo.Image : ""
  );
  const [pdfFileLabel, setPdfFileLabel] = useState(
    employeeInfo && employeeInfo?.IdProof
      ? employeeInfo?.IdProof
      : "PNG, JPEG, PDF Format"
  );

  const [idProof, setIdProof] = useState(
    employeeInfo && employeeInfo?.IdProof
      ? Array.from(new Set(Array.from(employeeInfo?.IdProof)))
          .join("")
          .replace(" ", "")
      : ""
  );

  const [workingUnit, setWorkingUnit] = useState(
    employeeInfo && employeeInfo?.WorkingUnit ? employeeInfo?.WorkingUnit : ""
  );
  const [section, setSection] = useState(
    employeeInfo && employeeInfo?.Section ? employeeInfo?.Section : ""
  );
  const [punchingId, setPunchingId] = useState(
    employeeInfo && employeeInfo?.PunchingId ? employeeInfo?.PunchingId : ""
  );
  const [magneticId, setMagneticId] = useState(
    employeeInfo && employeeInfo?.MagneticId ? employeeInfo?.MagneticId : ""
  );
  const [contactNo, setContactNo] = useState(
    employeeInfo && employeeInfo?.ContactNo ? employeeInfo?.ContactNo : ""
  );

  const [category, setCategory] = useState(
    employeeInfo && employeeInfo?.name ? employeeInfo?.name : "Select"
  );
  const [employeeId, setEmployeeId] = useState(
    employeeInfo && employeeInfo?.EmployeeId ? employeeInfo?.EmployeeId : ""
  );
  const [fullNameRequired, setFullNameRequired] = useState(true);
  const [employeeCodeRequired, setEmployeeCodeRequired] = useState(true);
  const [birthDateRequired, setBirthDateRequired] = useState(true);
  const [emailRequired, setEmailRequired] = useState(true);
  const [emergencyContactNoRequired, setEmergencyContactNoRequired] =
    useState(true);
  const [ertRoleRequired, setErtRoleRequired] = useState(false);
  const [addPhotoRequired, setAddPhotoRequired] = useState(true);
  const [IdProofRequired, setIdProofRequired] = useState(true);
  const [workingUnitRequired, setWorkingUnitRequired] = useState(true);
  const [sectionRequired, setSectionRequired] = useState(true);
  const [punchingIdRequired, setPunchingIdRequired] = useState(true);
  const [magneticIdRequired, setMagneticIdRequired] = useState(true);
  const [contactNoRequired, setContactNoRequired] = useState(true);
  const [categoryRequiredData, setCategoryRequiredData] = useState(false);
  const [isCamera, setIsCamera] = useState(false);
  const [show, setShow] = useState(true);
  const [empAlert, setEmpAlert] = useState(false);
  const [isWbCamEnabled, setWebCamEnabled] = useState(false);
  const [modalOpenStatus, setModalOpenStatus] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [categoryListDropDown, setCategoryListDropDown] = useState([]);
  const [categoryIdSelected, setcategoryIdSelected] = useState();
  const [validDates, setValidDates] = useState(true);
  const [dobDate, setDobDate] = useState("From Date");
  const [fromDate, setFromDate] = useState("From Date");
  const [ertList, setErtList] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [failedMessage, setFailedMessage] = useState("");
  const [failedMessageData, setFailedMessageData] = useState([]);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [showImagePreview, setShowImagePreview] = useState();
  const [statusCode, setStatusCode] = useState(0);

  const fullNameValidationCheck = () => {
    if (nonEmpty(fullName)) {
      setFullNameRequired(true);
      return true;
    } else {
      setFullNameRequired(false);
      return false;
    }
  };

  const punchingIdValidationCheck = () => {
    if (nonEmpty(punchingId)) {
      setPunchingIdRequired(true);
      return true;
    } else {
      setPunchingIdRequired(false);
      return false;
    }
  };

  const magneticIdValidationCheck = () => {
    if (nonEmpty(magneticId)) {
      setMagneticIdRequired(true);
      return true;
    } else {
      setMagneticIdRequired(false);
      return false;
    }
  };

  const employeeCodeValidationCheck = () => {
    if (nonEmpty(employeeCode)) {
      setEmployeeCodeRequired(true);
      return true;
    } else {
      setEmployeeCodeRequired(false);
      return false;
    }
  };
  // const birthDateValidationCheck = () => {
  //   if (nonEmpty(birthDate)) {
  //     setBirthDateRequired(true);
  //     return true;
  //   } else {
  //     setBirthDateRequired(false);
  //     return false;
  //   }
  // };
  const emailValidationCheck = () => {
    if (!validateEmail(email)) {
      setInvalidEmail(true);
      setEmailRequired(true);
      return false;
    } else if (nonEmpty(email)) {
      setInvalidEmail(false);
      setEmailRequired(true);
      return true;
    } else {
      setEmailRequired(false);
      setInvalidEmail(false);
      return false;
    }
  };

  const emergencyNumberValidationCheck = () => {
    if (
      nonEmpty(emergencyContactNo.toString()) &&
      validateMobileNumber(emergencyContactNo) &&
      emergencyContactNo.toString() != contactNo.toString()
    ) {
      setEmergencyContactNoRequired(true);
      return true;
    } else {
      setEmergencyContactNoRequired(false);
      return false;
    }
  };

  const idProofValidationCheck = () => {
    if (nonEmpty(idProof) && pdfFileLabel != "") {
      setIdProofRequired(true);
      return true;
    } else {
      setIdProofRequired(false);
      return false;
    }
  };

  const addPhotoValidationCheck = () => {
    if (nonEmpty(addPhoto) && photoLabel != "") {
      setAddPhotoRequired(true);
      return true;
    } else {
      setAddPhotoRequired(false);
      return false;
    }
  };

  // const workingUnitValidationCheck = () => {
  //   if (nonEmpty(workingUnit)) {
  //     setWorkingUnitRequired(true);
  //     return true;
  //   } else {
  //     setWorkingUnitRequired(false);
  //     return false;
  //   }
  // };

  // const sectionValidationCheck = () => {
  //   if (nonEmpty(section)) {
  //     setSectionRequired(true);
  //     return true;
  //   } else {
  //     setSectionRequired(false);
  //     return false;
  //   }
  // };

  const categoryValidationCheck = () => {
    if (nonEmpty(category) && category == "Select") {
      setCategoryRequiredData(true);
      return true;
    } else {
      setCategoryRequiredData(false);
      return false;
    }
  };

  const contactNumberValidationCheck = () => {
    if (
      nonEmpty(contactNo.toString()) &&
      validateMobileNumber(contactNo) &&
      contactNo.toString() != emergencyContactNo.toString()
    ) {
      setContactNoRequired(true);
      return true;
    } else {
      setContactNoRequired(false);
      return false;
    }
  };
  const ertRoleValidationCheck = () => {
    if (nonEmpty(ertRole) && ertRole == "Select") {
      setErtRoleRequired(true);
      return true;
    } else {
      setErtRoleRequired(false);
      return false;
    }
  };

  const navigate = useNavigate();
  const employeeProfile = () => {
    const fullNameValidation = fullNameValidationCheck();
    const punchingIdValidation = punchingIdValidationCheck();
    const magneticIdValidation = magneticIdValidationCheck();
    const employeeCodeValidation = employeeCodeValidationCheck();
    // const birthDateValidation = birthDateValidationCheck();
    const emailValidation = emailValidationCheck();
    const emergencyNumberValidation = emergencyNumberValidationCheck();
    const idProofValidation = idProofValidationCheck();
    // const workingUnitValidation = workingUnitValidationCheck();
    // const sectionValidation = sectionValidationCheck();
    const categoryValidation = categoryValidationCheck();
    const contactNumberValidation = contactNumberValidationCheck();
    const ertRoleValidation = ertRoleValidationCheck();
    const addPhotoValidation = addPhotoValidationCheck();
    if (
      fullNameValidation &&
      punchingIdValidation &&
      magneticIdValidation &&
      employeeCodeValidation &&
      emergencyNumberValidation &&
      idProofValidation &&
      !ertRoleValidation &&
      contactNumberValidation &&
      !categoryValidation &&
      addPhotoValidation &&
      emailValidation
    ) {
      if (isEdit) {
        callEditEmployeeApi(employeeId);
      } else {
        callEmployeeRegistration();
      }
    }
  };

  useEffect(() => {}, [category]);

  const getEmployeeData = () => {
    let formData = new FormData();
    formData.append("contactNo", contactNo);
    formData.append("section", section);
    formData.append("punchingId", punchingId);
    formData.append("emergencyContactNo", emergencyContactNo);
    formData.append("workingUnit", workingUnit);
    formData.append("empCode", employeeCode);
    formData.append("dob", birthDate);
    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("ERTRole", ertRole.id);
    formData.append("category", category.id);
    formData.append("magneticId", magneticId);
    formData.append("idProof", idProof);
    formData.append("image", addPhoto);

    return formData;
  };

  const callEmployeeRegistration = async () => {
    setEmployeeSpinnerStatus(true);
    try {
      const getData = await createEmployee(getEmployeeData());

      if (getData.data.status === 200) {
        setEmployeeSpinnerStatus(false);
        setShowAlert(true);
        setAlertMessage(getData.data.message);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 400
      ) {
        setEmployeeSpinnerStatus(false);
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else if (error.response.data.status === 403) {
        setEmployeeSpinnerStatus(false);
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else {
        setEmployeeSpinnerStatus(false);
        setShowAlert(true);
        setAlertMessage("Somethingwent wrong");
      }
      // alert("Somethingwent wrong");
    }
  };

  const callEditEmployeeApi = async () => {
    const EmployeeId = employeeInfo && employeeInfo.EmployeeId;
    setEmployeeSpinnerStatus(true);

    try {
      const getData = await editEmployee(getEmployeeData(), EmployeeId);
      if (getData.data.status === 200) {
        setEmployeeSpinnerStatus(false);
        setShowAlert(true);
        setAlertMessage(getData.data.message);
      }
    } catch (error) {
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        setEmployeeSpinnerStatus(false);
        const errorMessage = error.response.data.message;
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else {
        setEmployeeSpinnerStatus(false);
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      }
    }
  };
  const callCategoryList = async () => {
    try {
      const getData = await getCategoryList();
      if (getData.data.status === 200) {
        const currentCategory = getData?.data?.data?.categories?.find(
          (item) => item.id === employeeInfo?.CategoryId
        );
        setCategory(currentCategory ? currentCategory : "Select");
        setCategoryListDropDown(getData.data.data.categories);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        const errorMessage = error.response.data.message;
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };
  const callERTList = async () => {
    try {
      const getData = await getERTList();

      if (getData.data.status === 200) {
        const ertName = getData?.data?.data?.ert?.find(
          (item) => item.id === employeeInfo?.ERTId
        );
        setErtRole(ertName ? ertName : "Select");
        setErtList(getData?.data?.data?.ert);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        const errorMessage = error.response.data.message;
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Somethingwent wrong");
      }
    }
  };

  const getExcelFileData = () => {
    let formData = new FormData();
    formData.append("empList", groupExcelFile);
    return formData;
  };

  const employeeGroupEntry = async () => {
    if (groupExcelFile === false) {
      setGroupExcelRequired(false);
      return;
    } else {
      setGroupExcelRequired(true);
    }

    try {
      const respone = await createEmpGroup(getExcelFileData());
      if (respone?.data?.status === 200) {
        setEmpAlert(true);
        setSuccessMessage(respone?.data?.message?.success);
        setFailedMessage(respone?.data?.message?.failed?.message);
        const failedMessage = respone?.data?.message?.failed?.details?.map(
          (item, index) => {
            return (
              <div className="dataFailed" key={index}>
                {item?.reason}
              </div>
            );
          }
        );
        setFailedMessageData(failedMessage);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error.response.data.status === 400 ||
        error.response.data.status === 401
      ) {
        setAlertMessage(error?.response?.data?.message);
        setShowAlert(true);
      } else {
        setAlertMessage("Something went wrong");
        setShowAlert(true);
      }
    }
  };

  const submitData = () => {
    entryType === "I" && employeeProfile();
    entryType === "G" && employeeGroupEntry();
  };

  useEffect(() => {
    callCategoryList();
    callERTList();
  }, []);
  const goBack = () => {
    navigate(RouteConstants.EMPLOYEE_MASTER);
    // navigate(-1);
  };
  const handleShow = () => setShow(true);
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContents.LOGIN);
  };
  const navigateToEmployeeMaster = () => {
    navigate(RouteContents.EMPLOYEE_REGISTRATION);
  };

  // Function to close alert pop up
  const onSubmitCloseAlert = () => {
    setShowAlert(false);
    navigate(RouteConstants.EMPLOYEE_MASTER);
  };

  const providerValue = {
    employeeProfile,
    goBack,
    category,
    setCategory,
    fullName,
    setFullName,
    employeeCode,
    setEmployeeCode,
    birthDate,
    setBirthDate,
    email,
    setEmail,
    failedMessageData,
    emergencyContactNo,
    setEmergencyContactNo,
    ertRole,
    setErtRole,
    addPhoto,
    setAddPhoto,
    idProof,
    setIdProof,
    workingUnit,
    setWorkingUnit,
    section,
    failedMessage,
    setSection,
    empAlert,
    setEmpAlert,
    punchingId,
    setPunchingId,
    magneticId,
    setMagneticId,
    logout,
    contactNo,
    setContactNo,
    fullNameRequired,
    setFullNameRequired,
    statusCode,
    employeeCodeRequired,
    setEmployeeCodeRequired,
    birthDateRequired,
    setBirthDateRequired,
    emailRequired,
    setEmailRequired,
    emergencyContactNoRequired,
    setEmergencyContactNoRequired,
    ertRoleRequired,
    setErtRoleRequired,
    addPhotoRequired,
    setAddPhotoRequired,
    IdProofRequired,
    setIdProofRequired,
    workingUnitRequired,
    setWorkingUnitRequired,
    sectionRequired,
    setSectionRequired,
    punchingIdRequired,
    setPunchingIdRequired,
    magneticIdRequired,
    setMagneticIdRequired,
    contactNoRequired,
    setContactNoRequired,
    categoryRequiredData,
    setCategoryRequiredData,
    handleShow,
    isCamera,
    setIsCamera,
    show,
    setShow,
    isWbCamEnabled,
    setWebCamEnabled,
    modalOpenStatus,
    setModalOpenStatus,
    imgSrc,
    setImgSrc,
    categoryListDropDown,
    setCategoryListDropDown,
    showAlert,
    setShowAlert,
    alertMessage,
    categoryIdSelected,
    setcategoryIdSelected,
    navigateToEmployeeMaster,
    displayName,
    isEdit,
    callEditEmployeeApi,
    employeeId,
    setEmployeeId,
    validDates,
    setValidDates,
    dobDate,
    setDobDate,
    fromDate,
    setFromDate,
    ertList,
    setErtList,
    invalidEmail,
    setInvalidEmail,
    photoLabel,
    pdfFileLabel,
    setPhotoLabel,
    setPdfFileLabel,
    initialBdate,
    showImagePreview,
    setShowImagePreview,
    entryType,
    setEmployeeEntryType,
    groupExcelRequired,
    setGroupExcelRequired,
    groupExcelFile,
    setGroupExcelFile,
    successMessage,
    groupExcelFileLabel,
    setGroupExcelFileLabel,
    submitData,
    employeeSpinnerStatus,
    onSubmitCloseAlert, // Alert closing function
  };
  return (
    <EmployeeRegistrationContext.Provider value={providerValue}>
      {children}
    </EmployeeRegistrationContext.Provider>
  );
};
